import type { TOC } from '@ember/component/template-only';

interface GeneralTablesCellsTdTwoLineSignature {
  Args: {
    cellData: {
      primary: string;
      secondary?: string;
    };
  };
}

const GeneralTablesCellsTdTwoLine = <template>
  <div
    class="flex flex-col truncate py-200"
    data-test-td="two-line"
    title={{@cellData.primary}}
  >
    <span class="text-200--regular truncate">{{@cellData.primary}}</span>
    {{#if @cellData.secondary}}
      <span
        class="text-200--regular text-neutral-subdued truncate"
        title={{@cellData.secondary}}
      >{{@cellData.secondary}}</span>
    {{/if}}
  </div>
</template> satisfies TOC<GeneralTablesCellsTdTwoLineSignature>;

export default GeneralTablesCellsTdTwoLine;
